import React from 'react'
import { useHistory } from 'react-router-dom'
import { debounce } from 'lodash'
import TextField from '../../../src/features/common/TextField/TextField'
import SearchIcon from '@material-ui/icons/Search'

// given the debounced nature of the input handler, it's necesary to read
// directly the search query param in the url
// the search state is in: the url, the internal state, and the parent
// component that uses the debouncedHandler
// the state of the parent is decoupled of the internal state of this component
// and that decoupling causes the duplication of state.
// so, in the end, this component never reads the parent state directly
export default function PaginatedListSearchField({
  setValue,
  placeholder,
  searchQueryParam,
  disabled = false,
  maxLength,
  id = null,
  productType
}) {
  const history = useHistory()
  const inputRef = React.useRef({})

  const debouncedSearchHandler = debounce((value = '') => {
    setValue({ name: 'search', value: value.trim() })
  }, 500)

  React.useEffect(() => {
    inputRef.current.value =
      new URLSearchParams(history.location.search).get(searchQueryParam) || ''
    return history.listen((location, action) => {
      if (action === 'POP') {
        const queryString = new URLSearchParams(location.search)
        inputRef.current.value = queryString.get(searchQueryParam) || ''
      }
    })
    // history is a dependency but is a mutable object so its reference never changes
  }, [])

  const handleOnChange = event => {
    debouncedSearchHandler(event.target.value)
  }

  const classByType = (classType) => {
    switch (classType) {
      case 'plan-ahorro':
        return 'plan-de-ahorro-paginated-list-search-field'
      case 'leads':
          return 'leads-search-field'
      case 'leads-commercial-advisor':
        return 'leads-search-field-commercial-advisor'
      default:
        return 'common-paginated-list-search-field'
    }
  }

  return (
    <div className={classByType(productType)}>
      <TextField
        id={id}
        inputRef={inputRef}
        size="small"
        placeholder={placeholder || "Buscar"}
        onChange={handleOnChange}
        maxLength={maxLength}
        disabled={disabled}
        icon={SearchIcon}
        autoComplete='off'
      />
    </div>
  )
}
